import React from 'react'

const MySalesSubcategory: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_703_38272)" />
    <path
      d="M42.9698 27.7949C42.3492 27.7949 41.7803 27.8466 41.2631 27.7949C40.9527 27.7432 40.5907 27.5363 40.4873 27.3294C40.3838 27.1226 40.4355 26.6571 40.6424 26.4502C42.0389 24.7434 43.487 23.0884 44.8834 21.3817C45.2972 20.8645 45.8144 20.8645 46.2282 21.4334C47.6246 23.0884 49.0727 24.7434 50.4175 26.4502C50.5726 26.6571 50.6761 27.1226 50.5726 27.3294C50.4692 27.588 50.0554 27.7949 49.7968 27.7949C49.2279 27.8466 48.7107 27.7949 48.0383 27.7949C48.0383 28.0535 48.0383 28.3121 48.0383 28.5707C48.0383 34.984 48.0383 41.3455 48.0383 47.7587C48.0383 48.7414 47.7797 49 46.7971 49C45.9178 49 45.0386 49 44.1594 49C43.2284 49 42.9698 48.7414 42.9698 47.8104C42.9698 42.5868 42.9698 37.3631 42.9698 32.1394C42.9698 30.7429 42.9698 29.2948 42.9698 27.7949Z"
      fill="white"
    />
    <path
      d="M35.1604 40.5179C35.1604 38.0871 35.1604 35.6563 35.1604 33.1737C35.1604 32.191 35.3673 32.0359 36.3499 32.0359C37.3326 32.0359 38.2636 32.0359 39.2463 32.0359C39.9703 32.0359 40.2289 32.2945 40.2289 33.0186C40.2289 37.9837 40.2289 43.0005 40.2289 47.9656C40.2289 48.6379 39.9186 48.9482 39.2463 48.9482C38.2636 48.9482 37.2292 48.9482 36.2465 48.9482C35.4707 48.9482 35.2121 48.6896 35.2121 47.9138C35.1087 45.4313 35.1604 43.0005 35.1604 40.5179Z"
      fill="white"
    />
    <path
      d="M32.3156 43.0523C32.3156 44.6556 32.3156 46.2589 32.3156 47.8622C32.3156 48.7414 32.057 49 31.1778 49C30.1951 49 29.2641 49 28.2815 49C27.5574 49 27.2471 48.6897 27.2471 47.9656C27.2471 44.6556 27.2471 41.3972 27.2471 38.0872C27.2471 37.3631 27.5574 37.1045 28.2815 37.1045C29.2641 37.1045 30.2985 37.1045 31.2812 37.1045C32.0053 37.1045 32.3156 37.4148 32.3156 38.1389C32.3156 39.7422 32.3156 41.3972 32.3156 43.0523Z"
      fill="white"
    />
    <path
      d="M24.4543 45.5866C24.4543 46.3624 24.4543 47.1382 24.4543 47.9139C24.4543 48.6897 24.144 49.0001 23.3682 49.0001C22.3855 49.0001 21.4028 49.0001 20.4201 49.0001C19.6443 49.0001 19.3857 48.6897 19.3857 47.9657C19.3857 46.3624 19.3857 44.8108 19.3857 43.2075C19.3857 42.4317 19.6961 42.1731 20.4201 42.1213C21.4028 42.1213 22.4372 42.1213 23.4199 42.1213C24.1957 42.1213 24.4543 42.4317 24.4543 43.2075C24.506 43.9832 24.4543 44.759 24.4543 45.5866Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_703_38272"
        x1="34.5455"
        y1="2.70945e-07"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7000FF" />
        <stop offset="1" stopColor="#45009C" />
      </linearGradient>
    </defs>
  </svg>
)

export default MySalesSubcategory
